var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossLaunch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.33301C6.36819 9.33301 6.66699 9.63181 6.66699 10V17.333H14C14.3682 17.333 14.667 17.6318 14.667 18V19.333C14.667 19.7012 14.3682 20 14 20H5.33301C4.59689 19.9998 4.00018 19.4031 4 18.667V10C4 9.63181 4.2988 9.33301 4.66699 9.33301H6ZM20 12L16.9424 8.94238L11.5615 14.3232C11.3012 14.5834 10.8794 14.5835 10.6191 14.3232L9.67578 13.3809C9.41571 13.1205 9.41565 12.6978 9.67578 12.4375L15.0566 7.05664L12 4H20V12Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossLaunch);
export default __webpack_public_path__ + "static/media/CrossLaunch.5bb7a53dde212f47b2ed00d5dc92e8d7.svg";
export { ForwardRef as ReactComponent };